export default __webpack_public_path__ + "static/media/avatar_cheshire_cat10.108442bc.mp3";